module.exports = __webpack_public_path__ + "img/chooseOs.11a55f1.svg";